import { render, staticRenderFns } from "./Pests.vue?vue&type=template&id=54f4d1fb&"
import script from "./Pests.vue?vue&type=script&lang=js&"
export * from "./Pests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports